<template>
    <!--<el-popover class="template-demo"-->
    <!--v-if="firstVisit"-->
    <!--placement="bottom"-->
    <!--width="400"-->
    <!--v-model="visible">-->
    <!--<div>-->
    <!--<p class="td-title">可通过下载案例，更快速地上传模板进行配置</p>-->
    <!--<div class="td-body">-->
    <!--<div class="td-left">-->

    <!--</div>-->
    <!--<div class="td-right">-->

    <!--</div>-->
    <!--</div>-->
    <!--<div class="td-footer">-->
    <!--<el-button type="primary" class="c-f-right" @click="onConfirm">确认</el-button>-->
    <!--</div>-->
    <!--</div>-->
    <!--<el-button class="c-f-right" slot="reference"  type="default" round>下载案例<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></el-button>-->
    <!--</el-popover>-->
    <el-dropdown  trigger="click" class="c-f-right">
        <el-button type="default" round ref="dropdownRef">下载案例<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a download="【图文】.命名规则.psd" href="psd/tuwen.psd">下载图文案例</a></el-dropdown-item>
            <el-dropdown-item><a download="【banner】.有行动点.psd" href="psd/banner.psd">下载单图案例</a></el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
  export default {
    data() {
      return {
        firstVisit: true, // 首次显示弹框提示，点击确认后，以后只显示下拉下载列表
        visible: false
      };
    },
    created() {
      this.init();
    },
    methods: {
      init() {
      },
      onConfirm() {
      }
    }
  }
</script>